// extracted by mini-css-extract-plugin
export default {"box":"cart_box__91Z4H","on":"cart_on__9952l","discount":"cart_discount__gOUae","pay":"cart_pay__nxkKG","box2":"cart_box2__NPAhQ","off":"cart_off__DArjZ"};